import { useState } from "react";

export const useGlobalData = () => {
  const [data] = useState({
    date: "Sept 7-10",
    year: new Date().getFullYear(),
    shortYear: new Date().getFullYear().toString().slice(-2),
    location: "San Diego, CA",
  });

  return data;
};
